export const version = "address/5.2.0";
